import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiCall } from "../../../API";
import * as Toast from "../../../components/shared/Toast";

export const heartBeatACTION = createAsyncThunk(
    "HeartBeat/GetAllRestaurantposheartbeat",
    async (data) => {
        let d = {
            device: data.device || 1,
            pageNo: data.pageNo !== undefined ? data.pageNo : -1,
            pageSize: data.pageSize !== undefined ? data.pageSize : 0,
            sortBy: data.sortBy || 0,
            sortOrder: data.sortOrder || 0,
            filter: { ...data.filter },
            restaurantID: data.restaurantID
        };
        return apiCall("/manage/business/restaurantposheartbeat/getall", "POST", d, false)
            .then((response) => {
                if (response.status === 200) {
                    if (!response.data.hasError) {
                        return {
                            ...response.data
                        };
                    } else {
                        Toast.error(response.data.Message.Message);
                        return Promise.reject({
                            ...response.data.Message,
                        });
                    }
                }
            })
            .catch((error) => {
                Toast.error(error);
                return Promise.reject({
                    ...error,
                });
            });
    }
);

export const getAllRestaurantAction = createAsyncThunk(
    "HeartBeat/GetAllRestaurantposheartbeatDropdown",
    async (data) => {
        return apiCall("/manage/business/restaurantposheartbeat/getall", "POST", data, false)
            .then((response) => {
                if (response.status === 200) {
                    if (!response.data.hasError) {
                        return {
                            ...response.data
                        };
                    } else {
                        Toast.error(response.data.Message.Message);
                        return Promise.reject({
                            ...response.data.Message,
                        });
                    }
                }
            })
            .catch((error) => {
                Toast.error(error);
                return Promise.reject({
                    ...error,
                });
            });
    }
);